import React from 'react';
import './SummaryCard.css';
import AudioPlayer from '../AudioPlayer';

const SummaryCard = ({ 
  expanded = false, 
  onToggle = () => {},
  title = '',
  content = '',
  keyThemes = [],
  characters = [],
  chunk = '',
  cefrLevel = '',
  audioSrc = '',
  audioTitle = '',
  showAudio = true,
  showThemes = true,
  showCharacters = true,
  showChunkInfo = true,
  showCefrInfo = true,
  customHeader = '',
  onAudioPlay = () => {},
  onAudioPause = () => {},
  onAudioEnded = () => {}
}) => {
  
  // Show placeholder if no content is available
  const hasContent = content || title || keyThemes.length > 0 || characters.length > 0;
  
  if (!hasContent) {
    return (
      <div className={`summary-card placeholder ${expanded ? 'expanded' : ''}`}>
        <div className="summary-header" onClick={onToggle}>
          <h3>
            <i 
              className={`fas fa-chevron-${expanded ? 'up' : 'down'}`}
              style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
            ></i>
            Chapter Summary
          </h3>
        </div>
        
        <div className="summary-content">
          <div className="summary-text placeholder-text">
            <em>Summary content will be available soon...</em>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`summary-card ${expanded ? 'expanded' : ''}`}>
      <div className="summary-header" onClick={onToggle}>
        <h3>
          <i 
            className={`fas fa-chevron-${expanded ? 'up' : 'down'}`}
            style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
          ></i>
          {customHeader || 'Click here for summary'}
        </h3>
      </div>
      
      <div className="summary-content">
          {/* Title */}
          {title && (
            <div className="summary-title">
              <h4>{title}</h4>
            </div>
          )}
          
          {/* Chunk and CEFR Info */}
          {(showChunkInfo || showCefrInfo) && (chunk || cefrLevel) && (
            <div className="summary-meta">
              {showChunkInfo && chunk && (
                <span className="meta-item">
                  <strong>Chunk:</strong> {chunk}
                </span>
              )}
              {showCefrInfo && cefrLevel && (
                <span className="meta-item">
                  <strong>CEFR Level:</strong> {cefrLevel}
                </span>
              )}
            </div>
          )}
          
          {/* Main Content */}
          {content && (
            <div className="summary-text">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          )}
          
          {/* Key Themes */}
          {showThemes && keyThemes.length > 0 && (
            <div className="summary-themes">
              <h5>Key Themes:</h5>
              <ul>
                {keyThemes.map((theme, index) => (
                  <li key={index}>{theme}</li>
                ))}
              </ul>
            </div>
          )}
          
          {/* Characters */}
          {showCharacters && characters.length > 0 && (
            <div className="summary-characters">
              <h5>Characters:</h5>
              <ul>
                {characters.map((character, index) => (
                  <li key={index}>{character}</li>
                ))}
              </ul>
            </div>
          )}
          
          {/* Audio Player */}
          {showAudio && audioSrc && (
            <div className="summary-audio">
              <AudioPlayer 
                audioSrc={audioSrc}
                title={audioTitle || "Chapter Summary Audio"}
                onPlay={onAudioPlay}
                onPause={onAudioPause}
                onEnded={onAudioEnded}
              />
            </div>
          )}
      </div>
    </div>
  );
};

export default SummaryCard;
